import { atomFamily, loadable } from "jotai/utils";
import { atom } from "jotai";
import { Member } from "../types";

type MembersAtomFamilyProps = {
  currentAccountId: number | undefined;
  search: string | undefined;
  allowTeams: boolean;
};

type FetchResponse = {
  results: Member[];
};

// Base atom that suspends
const membersAtomFamily_SUSPENDS = atomFamily(
  ({ currentAccountId, search, allowTeams }: MembersAtomFamilyProps) => {
    const debugLabel = `membersAtomFamily_SUSPENDS({ search: ${search} })`;

    const membersAtom = atom<Promise<Member[]>>(async () => {
      if (!allowTeams) {
        return [];
      }

      const params = {
        limit: "10",
        offset: "0",
        search,
      };
      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined),
      ) as Record<string, string>;
      const query = new URLSearchParams(filteredParams);

      const res = await fetch(
        `/api/v4/accounts/${currentAccountId}/members?${query}`,
      );

      if (!res.ok) {
        throw new Error("Failed to fetch members");
      }

      const response: FetchResponse = await res.json();

      return response.results || [];
    });

    membersAtom.debugLabel = debugLabel;
    return membersAtom;
  },
  isEqual,
);

// Does NOT suspend due to loadable usage
export const membersAtomFamily = atomFamily((props: MembersAtomFamilyProps) => {
  const baseAtom = membersAtomFamily_SUSPENDS(props);
  return loadable(baseAtom);
}, isEqual);

function isEqual(a: MembersAtomFamilyProps, b: MembersAtomFamilyProps) {
  return a.search === b.search;
}
